import { render, staticRenderFns } from "./BdKaroFinancialAffairsConfig.vue?vue&type=template&id=12f2c15b&"
import script from "./BdKaroFinancialAffairsConfig.vue?vue&type=script&lang=js&"
export * from "./BdKaroFinancialAffairsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports